import { Download, FileText } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

const PORTFOLIO_ES =
  "https://customer-assets.emergentagent.com/job_vertex-landing/artifacts/zqgxmdxp_PORTAFOLIO%20ESPA%C3%91OL.pdf";
const PORTFOLIO_EN =
  "https://customer-assets.emergentagent.com/job_vertex-landing/artifacts/gcc0zfmr_PORTFOLIO%20DIEGO%20INGLES.pdf";

const FlagMX = () => (
  <svg viewBox="0 0 6 4" className="w-7 h-5 rounded-sm overflow-hidden shrink-0" aria-hidden="true">
    <rect width="2" height="4" x="0" fill="#006847" />
    <rect width="2" height="4" x="2" fill="#ffffff" />
    <rect width="2" height="4" x="4" fill="#ce1126" />
    <circle cx="3" cy="2" r="0.45" fill="none" stroke="#8b4513" strokeWidth="0.08" />
  </svg>
);

const FlagUS = () => (
  <svg viewBox="0 0 7410 3900" className="w-7 h-5 rounded-sm overflow-hidden shrink-0" aria-hidden="true">
    <rect width="7410" height="3900" fill="#b22234" />
    {Array.from({ length: 6 }).map((_, i) => (
      <rect key={i} y={300 + i * 600} width="7410" height="300" fill="#ffffff" />
    ))}
    <rect width="2964" height="2100" fill="#3c3b6e" />
  </svg>
);

export const Portfolio = () => {
  const ref = useReveal();
  return (
    <section
      id="portafolio"
      data-testid="portfolio-section"
      className="relative py-24 md:py-36 bg-[#e5e3dc]/60"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div ref={ref} className="reveal grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#ca0013]" />
              <span className="font-label text-xs text-[#ca0013]">
                Portafolio
              </span>
            </div>
            <h2
              data-testid="portfolio-title"
              className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95]"
            >
              Portafolio{" "}
              <span className="font-editorial text-[#ca0013] font-normal">
                /
              </span>{" "}
              <span className="font-editorial text-[#ca0013] font-normal">
                Portfolio
              </span>
            </h2>
            <p
              data-testid="portfolio-description"
              className="font-body text-base md:text-lg text-[#4a4a4a] mt-6 leading-relaxed max-w-md"
            >
              Descarga mi portafolio en español o inglés para conocer mi
              experiencia y proyectos.
            </p>
            <div className="hidden lg:flex items-center gap-3 mt-10 text-[#4a4a4a]">
              <FileText size={18} />
              <span className="font-body text-sm">
                Formato PDF · Listo para imprimir
              </span>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            <a
              data-testid="portfolio-download-es"
              href={PORTFOLIO_ES}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="group relative bg-white border border-black/10 p-6 md:p-8 hover:border-[#ca0013] hover:-translate-y-1 transition-all duration-500 flex flex-col justify-between min-h-[220px]"
            >
              <div className="flex items-start justify-between">
                <FlagMX />
                <Download
                  size={22}
                  className="text-[#111] group-hover:text-[#ca0013] group-hover:translate-y-1 transition-all"
                />
              </div>
              <div>
                <div className="font-label text-xs text-[#4a4a4a]">Español</div>
                <h3 className="font-display text-2xl md:text-3xl tracking-tight leading-tight mt-2">
                  Descargar
                  <br />
                  <span className="font-editorial text-[#ca0013] font-normal">
                    Portafolio
                  </span>
                </h3>
              </div>
            </a>

            <a
              data-testid="portfolio-download-en"
              href={PORTFOLIO_EN}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="group relative bg-[#111] text-[#eeede9] border border-[#111] p-6 md:p-8 hover:bg-[#ca0013] hover:border-[#ca0013] hover:-translate-y-1 transition-all duration-500 flex flex-col justify-between min-h-[220px]"
            >
              <div className="flex items-start justify-between">
                <FlagUS />
                <Download
                  size={22}
                  className="group-hover:translate-y-1 transition-all"
                />
              </div>
              <div>
                <div className="font-label text-xs text-[#eeede9]/70">English</div>
                <h3 className="font-display text-2xl md:text-3xl tracking-tight leading-tight mt-2">
                  Download
                  <br />
                  <span className="font-editorial text-[#eeede9] font-normal">
                    Portfolio
                  </span>
                </h3>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
